import React, { Fragment } from 'react';
import {Icon} from "antd";

import Block from '../Block';

import "./style.css"

export default props => {
  return (
    <Fragment>
      <Block className="indexBox">
        {props.index
          ?
          <h3 className="isoBoxTitle index-box-title">
            {props.index}
          </h3>
          : ""}
        {props.title
          ? <h3 className="isoBoxTitle detail-title">
            {' '}{props.title}{' '}
            {(props.onMoveAbove || props.onMoveBelow) && (
              <Block className="caret-block">
                {props.onMoveAbove && (
                  <Icon type="caret-up" theme="filled" onClick={props.onMoveAbove} />
                )}
                {props.onMoveBelow && (
                  <Icon type="caret-down" theme="filled" onClick={props.onMoveBelow} />
                )}
              </Block>
            )}
          </h3>
          : ''}
      </Block>
      <Block className="box-subtitle">
        {props.subtitle
          ? <p className="isoBoxSubTitle">
            {' '}{props.subtitle}{' '}
          </p>
          : ''}
      </Block>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/ui-ant/IndexBlockTitle/index.js